import {
  TFeatureFlag,
  TFeatureFlagResponse,
} from '../../../repositories/aecomStrapiCms/featureFlags/types';

export class FeatureFlagsService {
  private flags: Record<string, TFeatureFlag> = {};

  initialize(response: TFeatureFlagResponse): void {
    this.flags = response.data.reduce(
      (acc, flag) => {
        acc[flag.attributes.key] = flag;
        return acc;
      },
      {} as Record<string, TFeatureFlag>,
    );
  }

  isEnabled(key: string): boolean {
    if (typeof window === 'undefined') {
      return false;
    }

    const flag = this.flags[key];
    if (!flag) {
      return false;
    }

    return flag.attributes.enabled;
  }

  getAllFlags(): Record<string, TFeatureFlag> {
    return { ...this.flags };
  }
}
